import React from 'react';
import classnames from 'classnames';

import Is, { Props as IsProps, IsComponent } from '@/components/Is';
import Loading from '@/components/Loading';

import style from './Button.sass';

export type Props<T extends IsComponent> = Omit<IsProps<T>, 'size'> & {
  appearance: 'primary' | 'secondary';
  size?: 'large';
  block?: boolean;
  loading?: boolean;
};

export default class Button<T extends IsComponent> extends React.PureComponent<Props<T>> {
  static defaultProps: Pick<Props<any>, 'is'> = {
    is: 'button'
  };

  render() {
    const { appearance, size, block, loading, className, children, ...rest } = this.props;

    return (
      // @ts-ignore
      <Is
        className={classnames(
          style.root,
          {
            [style.block]: block,
            [style[size!]]: !!size,
            [style.loading]: loading
          },
          style[appearance!],
          className
        )}
        {...rest}
      >
        {loading === undefined ? (
          children
        ) : (
          <React.Fragment>
            <span className={style.loader}>
              <Loading visible={!!loading} center>
                <Loading.Indicator
                  size={parseInt(style.normalSize, 10) / 1.5}
                  borderWidth={parseInt(style.normalSize, 10) / 20}
                  color={(style as any)[`${appearance}LoadingColor`]}
                />
              </Loading>
            </span>

            <span className={style.content}>{children}</span>
          </React.Fragment>
        )}
      </Is>
    );
  }
}
